// register.js
import React from 'react';
import View from 'src/pages/auth/register';
import useViewModel from 'src/api/register/view-model';
import { paths } from 'src/paths';
import { useRouter } from 'src/hooks/use-router';

const Page = () => {
  const router = useRouter();
  const onSuccess = () => {
    router.push(paths.myauth.index);
  };

  const onError = (helpers, msg) => {
    helpers.setStatus({ success: false });
    helpers.setErrors({ submit: msg });
    helpers.setSubmitting(false);
  };
  const { formik } = useViewModel(onSuccess, onError);

  return <View formik={formik} />;
};

export default Page;
